import request from '@/utils/request'

// 获取文章详情列表
export function getArticleListDetail(data) {
    return request({
        url: '/api/m22129/6a83c6ff0f643',
        method: 'POST',
        data
    })
}

// 新闻资讯页表
export function getArticleList(data) {
    return request({
        url: '/api/m22129/6a83c4c1972e1',
        method: 'POST',
        data
    })
}

// 查询首页卡片
export function getHomecard(data) {
    return request({
        url: '/api/m22129/6a83bfb7becf0',
        method: 'POST',
        data
    })
}

// 操作留言列表
export function addMsgManagement(data) {
    return request({
        url: '/api/m22129/6a83bcf6be9a1',
        method: 'POST',
        data
    })
}

// 获取图形验证码（入参：{ area_code, phone }；返回 data.image 为 base64 图片）
export function getCaptcha(data) {
    return request({
        url: '/api/m22129/6aa915a88eea5',
        method: 'POST',
        data
    })
}

// 获取手机号国际区号
export function getCountryCode(data) {
    return request({
        url: '/api/m22129/6a84053b14547',
        method: 'POST',
        data
    })
}

// 获取关于我们
export function getAboutUs(data) {
    return request({
        url: '/api/m22129/6a83fa54888fd',
        method: 'POST',
        data
    })
}

// 获取验证码（注册 type=1）
export function getCode(data) {
    return request({
        url: '/api/m22129/6a851ee5df2e8',
        method: 'POST',
        data
    })
}

// 获取验证码（登录 type=5） 
export function getLoginCode(data) {
    return request({
        url: '/api/m22129/6a851ee5df2e8',
        method: 'POST',
        data
    })
}
// 获取验证码（修改密码 type=10）
export function getChangeCode(data) {
    return request({
        url: '/api/m22129/6a851ee5df2e8',
        method: 'POST',
        data
    })
}

// 校验验证码  
export function jiaoyanCode(data) {
    return request({
        url: '/api/m22129/6a855807ea312',
        method: 'POST',
        data
    })
}


// 注册账号
export function register(data) {
    return request({
        url: '/api/m22129/6a855c55defc7',
        method: 'POST',
        data
    })
}

// 手机号密码/验证码登录
export function login(data) {
    return request({
        url: '/api/m22129/6a8426e077f8f',
        method: 'POST',
        data
    })
}

// LinkedIn 第三方登录（后端用授权码 code 换取登录态）
// 入参示例：{ code, state, redirect_uri }
// 返回示例：{ user_token, user_info... }，结构同手机号登录
export function linkedInLogin(data) {
    return request({
        url: '/api/m22129/6aa7aefe978c1', // TODO: 替换为后端 LinkedIn 登录接口 ID
        method: 'POST',
        data
    })
}

// Facebook 第三方登录（后端用授权码 code 换取登录态）
// 入参示例：{ code, state, redirect_uri }
// 返回示例：{ user_token, user_info... }，结构同手机号登录
export function facebookLogin(data) {
    return request({
        url: '/api/m22129/6aa7aefe978c1', // TODO: 替换为后端 Facebook 登录接口 ID
        method: 'POST',
        data
    })
}

// 修改用户信息
export function updateUserInfo(data) {
    return request({
        url: '/api/m22129/6a856e63151cb',
        method: 'POST',
        data
    })
}

// 上传图片（带进度回调）
// onProgress(percent) percent: 0~100
export function uploadImage(file, onProgress) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('module', '')
    formData.append('dir', '')
    return request({
        url: '/api/v1/5d5fa8984f0c2',
        method: 'POST',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data', 'user-token': '' },
        onUploadProgress: e => {
            if (onProgress && e.total) {
                onProgress(Math.round((e.loaded / e.total) * 100))
            }
        }
    })
}

// 货物追踪查询
export function searchTracking(data) {
    return request({
        url: '/api/m22129/6a87ac9eb6bd0',
        method: 'POST',
        data
    })
}

// 查询协议内容（aid: 1-用户注册协议, 2-隐私协议, 3-法律法规）
export function getPolicy(data) {
    return request({
        url: '/api/m22129/6a87bf09c1b07',
        method: 'POST',
        data
    })
}

// 获取系统配置（code 多个用逗号分隔，如 tel,web_site_address,web_company_name,web_site_description）
export function getSystemConfig(data) {
    return request({
        url: '/api/m22129/6a87c6a91e746',
        method: 'POST',
        data
    })
}

// 获取起始港口列表（portconfig_port_name: 起运港名称, portconfig_id: 目的港ID）
export function getOriginPorts(data) {
    return request({
        url: '/api/m22129/6a8fd62cdc06c',
        method: 'POST',
        data
    })
}

// 获取目的港口列表（port_name_2: 目的港名称, portconfig_id: 起始港ID）
export function getDestPorts(data) {
    return request({
        url: '/api/m22129/6a8fd7e3ebee0',
        method: 'POST',
        data
    })
}

// 获取箱型列表
export function getBoxTypes(data) {
    return request({
        url: '/api/m22129/6a8f90f0f3c0f',
        method: 'POST',
        data
    })
}

// 计算运费价格（type: 1=CIF拼柜, 5=CIF整柜, 10=FOB整柜, 15=DDP到门）
export function calcFreightPrice(data) {
    return request({
        url: '/api/m22129/6a8f920206360',
        method: 'POST',
        data
    })
}

// 获取亚马逊邮编列表（postal_code: 邮编筛选, portconfig_id: 目的港ID筛选）
export function getAmazonZips(data) {
    return request({
        url: '/api/m22129/6a9129fe3bb94',
        method: 'POST',
        data
    })
}

// 查询亚马逊线路对应港口（portconfig_port_name: 目的港, amazon_id: 亚马逊仓ID）
export function getAmazonPorts(data) {
    return request({
        url: '/api/m22129/6a912d56daf1a',
        method: 'POST',
        data
    })
}

// 获取发货地国家城市二层数据
// 返回：[{ aid, name, name_english, zip_code, children: [{ aid, name, ... }] }]
// 有 children 则需二级选择（省/州），无 children 则一级直接选国家
export function getShipCountryCity(data) {
    return request({
        url: '/api/m22129/6a97d94adc5ad',
        method: 'POST',
        data
    })
}

// 获取收货地国家城市二层数据
export function getRecvCountryCity(data) {
    return request({
        url: '/api/m22129/6a98e94a01d88',
        method: 'POST',
        data
    })
}

// 根据邮编+国家配置ID查询发货地港口
// 入参：{ zip_post: 邮编, countryconfig_id: 国家配置ID }
// 返回：[{ aid, port_name, zip_post, countryconfig_id }]
export function getShipPortsByZip(data) {
    return request({
        url: '/api/m22129/6a97e706ed1f5',
        method: 'POST',
        data
    })
}

// 获取地址类型列表
// 入参：{ type: 1=发货地址, 5=收货地址 }
// 返回：[{ type, name, type_name }]
export function getAddressTypes(data) {
    return request({
        url: '/api/m22129/6a98e3af998ea',
        method: 'POST',
        data
    })
}

// 查询收货地港口
export function getDestPrivatePorts(data) {
    return request({
        url: '/api/m22129/6a98e99c81374',
        method: 'POST',
        data
    })
}



// 获取客服链接  
export function getChatUrl(data) {
    return request({
        url: '/api/m22129/6a9f6c59ea724 ',
        method: 'POST',
        data
    })
}

// 验证码修改密码
// 入参：{ password: 新密码, phone_code: 区号, mobile: 手机号, code: 验证码 }
export function changePassword(data) {
    return request({
        url: '/api/m22129/6a856abcdb23d ',
        method: 'POST',
        data
    })
}


